module.exports = __webpack_public_path__ + "static/media/rewards.6b231726.svg";